import { Component, ViewChild } from "@angular/core"
import { ActivatedRoute, Router } from "@angular/router"
import { MenuController } from "@ionic/angular"
import { ClientProspectComponent } from "projects/client-prospect/src/lib/client-prospect.component"
import { AppSession } from "projects/core/src/lib/core/AppSession"
import { AppStorage } from "projects/core/src/lib/core/AppStorage"
import { MessageService } from "projects/core/src/lib/core/MessageService"
import { ResponseModel } from "projects/core/src/lib/core/model/ResponseModel"
import { TokenModel } from "projects/core/src/lib/core/model/TokenModel"
import { UsuarioModel } from "projects/core/src/lib/core/model/UsuarioModel"
import { UsuarioProvider } from "projects/core/src/lib/core/provider/UsuarioProvider"
import { ThrowError } from "projects/core/src/lib/core/ThrowError"
import { BasePage } from "../base.page"

@Component({
  selector: 'client-prospect-page',
  templateUrl: 'client-prospect.page.html',
  styleUrls: ['client-prospect.page.scss']
})
export class ClientProspectPage extends BasePage {

  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private menu: MenuController) {
    super(router)
  }

  @ViewChild('clientProspectComponent') clientProspectComponent: ClientProspectComponent

  usuario: UsuarioModel = new UsuarioModel()
  showBackButton = true
  token
  usuarioProvider = new UsuarioProvider()

  async ngOnInit(): Promise<void> {
    await this.handlerFlowWeb()
    this.getUserInfo()
    this.initObservable()
  }

  async handlerFlowWeb() {
    this.token = this.activatedRoute.snapshot.paramMap.get('token');

    if (this.token) {
      let modelToken = new TokenModel()
      modelToken.access_token = this.token
      modelToken.token_type = "Bearer"
      await AppStorage.set(AppSession.CHAVE_TOKEN, modelToken)
      await AppStorage.set(AppSession.CHAVE_IS_WEB, true)

      this.menu.enable(false)

      if (this.clientProspectComponent.currentStep == 0) {
        this.showBackButton = false
      }

      await this.processoObtemInformacoesUsuario()
    }
  }

  async processoObtemInformacoesUsuario() {
    const retorno = await this.usuarioProvider.informacoesUsuario();
    if (retorno.status == ResponseModel.STATUS_OK) {
      await AppSession.saveUser(retorno.data)
    } else {
        throw Error(ThrowError.MESSAGE_DEFAULT)
    }
  }

  clickBackButton() {
    // Imcomplete Page
    if (this.clientProspectComponent.currentStep == 0 || !this.clientProspectComponent.client.name) {
      this.openPage("")
    } else {
      this.clientProspectComponent.btnClickBack()
    }
  }

  initObservable() {
    MessageService.getMessage().subscribe(response => {
      if (response && response.identifyObservable == MessageService.KEY_CLIENT_PROSPECT_SHOW_BACK_BUTTON) {
        this.showBackButton = true
      } else if (response && response.identifyObservable == MessageService.KEY_CLIENT_PROSPECT_HIDE_BACK_BUTTON) {
        this.showBackButton = false
      }
    })
  }

  async getUserInfo() {
    this.usuario = await AppSession.getUser()
  }
}